module.exports = __webpack_public_path__ + "images/token-overlay-960x146-5f5f6917eb7508263d52eed4fdbf3bcd.png";